module.exports = __webpack_public_path__ + "static/socialmedia-8659cf288dad27e745b50f1118dc1423.svg";